import { createCustomTheme, IgCustomTheme } from "@intelligems/ig-theme";

declare module "@mui/material/styles" {
  interface Theme {
    [key: string]: any;
  }

  interface ThemeOptions {
    [key: string]: any;
  }
}
declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    black: true;
  }
}

declare module "@mui/material/styles/createPalette" {
  interface Palette {
    black: Palette["primary"];
    gray: Palette["primary"];
    disabled: Palette["primary"];
  }

  interface PaletteOptions {
    black?: Palette["primary"];
    gray?: Palette["primary"];
    disabled?: Palette["primary"];
  }
}

const theme = createCustomTheme() as IgCustomTheme;

export default theme;

export const Theme = typeof theme;
